import React, { useEffect, useState } from "react";

import { TabMenu } from "primereact/tabmenu";
import { Outlet, useNavigate } from "react-router-dom";
import useProjectContext from "../hooks/useProjectContext";
import ProjectDropDown from "./ProjectDropDown";

const Layout = () => {
  const [activeIndex, setActiveIndex] = useState(2);
  const { projectId, user} = useProjectContext();

  useEffect(() => {
    const { hash } = window.location;
    if (hash === `#/${projectId}/` || hash === `#/${projectId}`) return setActiveIndex(0);
    if (hash === `#/${projectId}/devices`) return setActiveIndex(1);
    if (hash === `#/${projectId}/analytics`) return setActiveIndex(2);
    if (hash === `#/${projectId}/jobs`) return setActiveIndex(3);
    if (hash === `#/${projectId}/map`) return setActiveIndex(4);
    if (hash === `#/${projectId}/settings`) return setActiveIndex(5);
    return setActiveIndex(10);
  }, [window.location.hash]);
  
  const navigate = useNavigate();
  const items = [
    {
      label: "Objects",
      icon: "pi pi-list",
      command: () => {
        navigate("");
      },
    },
    {
      label: "Devices",
      icon: "pi pi-list",
      command: () => {
        navigate("devices");
      },
    },
    {
      label: "Analytics",
      icon: "pi pi-chart-line",
      command: () => {
        navigate("analytics");
      },
    },
    {
      label: "Jobs",
      icon: "pi pi-briefcase",
      command: () => {
        navigate("jobs");
      },
    },
    {
      label: "Map",
      icon: "pi pi-map",
      command: () => {
        navigate("map");
      },
    },
    {
      label: "Settings",
      icon: "pi pi-cog",
      command: () => {
        navigate("settings");
      },
    },
  ];

  return (
    <div>
      <div className="flex gap-1">
        {projectId && (
          <TabMenu
            model={items}
            className="flex-1 justify-content-end"
            activeIndex={activeIndex}
            onTabChange={e => setActiveIndex(e.index)}
          />
        )}
        {user?.companyRef && <ProjectDropDown />}
      </div>
      <Outlet />
    </div>
  );
};

export default Layout;
